const initialState = {
  cartItems: JSON.parse(localStorage.getItem("cartItems")) || [],
};

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_CART": {
      const item = action.payload;
      const existIndex = state.cartItems.findIndex(
        (x) => x.cartKey === item.cartKey,
      );

      if (existIndex >= 0) {
        const updatedItems = [...state.cartItems];
        updatedItems[existIndex] = {
          ...updatedItems[existIndex],
          ...item,
          quantity: updatedItems[existIndex].quantity + item.quantity,
        };

        return { ...state, cartItems: updatedItems };
      }

      return { ...state, cartItems: [...state.cartItems, item] };
    }
    case "UPDATE_CART_ITEMS":
      return { ...state, cartItems: action.payload };
    case "CART_UPDATE_QTY": {
      const { cartKey, action: qtyAction } = action.payload;
      const updatedItems = state.cartItems.map((item) => {
        if (item.cartKey !== cartKey) {
          return item;
        }

        const newQty =
          qtyAction === "increase"
            ? item.quantity + 1
            : Math.max(1, item.quantity - 1);

        return {
          ...item,
          quantity: newQty,
        };
      });

      return { ...state, cartItems: updatedItems };
    }

    case "REMOVE_CART":
      return {
        ...state,
        cartItems: state.cartItems.filter(
          (item) => item.cartKey !== action.payload,
        ),
      };

    case "CLEAR_CART":
      return { ...state, cartItems: [] };

    default:
      return state;
  }
};
